// This is meant to be used in tandem with create-fetch-action-creators.
// If you are not able to use a standard action creator, then this reducer isnt for you
export const createFetchReducer = ({ loadActionType, failureActionType, successActionType, shouldSaveData, }) => (state = {}, action = {}) => {
    switch (action.type) {
        case loadActionType:
            return Object.assign(Object.assign({}, state), { data: shouldSaveData ? state.data : null, error: null, isLoading: true });
        case failureActionType:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.error, lastError: Date.now() });
        case successActionType:
            return Object.assign(Object.assign({}, state), { isLoading: false, data: action.data, lastSuccess: Date.now() });
        default:
            return state;
    }
};
//# sourceMappingURL=create-fetch-reducer.js.map